export default __webpack_public_path__ + "static/media/lc-active-m.bbe7e3ab.svg";